import { useState } from "react";
import type { CommentItem } from "@/types/content";

const seedComments: CommentItem[] = [
  {
    id: "c-1",
    user: "影迷小周",
    avatar: "周",
    time: "2 小时前",
    content:
      "这个话题分析得挺到位的，尤其是把作品和舆论联系起来看，比单纯追热度有意思多了。",
  },
  {
    id: "c-2",
    user: "追剧的阿鹿",
    avatar: "鹿",
    time: "5 小时前",
    content:
      "补充一点：其实幕后团队的配合也很关键，希望后续能多一些创作视角的讨论。",
  },
  {
    id: "c-3",
    user: "深夜观影",
    avatar: "深",
    time: "1 天前",
    content: "看完了，感觉今年的整体水准确实在往上走，期待更多好作品。",
  },
];

export default function CommentSection() {
  const [comments, setComments] = useState<CommentItem[]>(seedComments);
  const [input, setInput] = useState("");

  const handleSubmit = () => {
    const value = input.trim();
    if (!value) return;
    const next: CommentItem = {
      id: `c-${Date.now()}`,
      user: "我",
      avatar: "我",
      time: "刚刚",
      content: value.slice(0, 500),
    };
    setComments((prev) => [next, ...prev]);
    setInput("");
  };

  return (
    <section className="mt-10">
      <div className="mb-4 flex items-center gap-2">
        <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
          用户评论
        </h2>
        <span className="rounded-full bg-background-100 px-2 py-0.5 text-xs text-foreground-500">
          {comments.length}
        </span>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
        <div className="flex flex-col gap-3">
          <textarea
            value={input}
            onChange={(event) => setInput(event.target.value.slice(0, 500))}
            rows={3}
            maxLength={500}
            placeholder="说说你的看法（演示功能，评论仅保存在当前页面）"
            className="w-full resize-none rounded-md border border-background-200 bg-background-100 p-3 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-300 placeholder:text-foreground-400"
          ></textarea>
          <div className="flex items-center justify-between gap-3">
            <span className="text-xs text-foreground-400">
              {input.length}/500 · 演示评论，无真实数据存储
            </span>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={!input.trim()}
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
            >
              发表评论
            </button>
          </div>
        </div>

        <div className="mt-5 flex flex-col gap-4 border-t border-background-200 pt-5">
          {comments.map((comment) => (
            <div key={comment.id} className="flex gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-sm text-secondary-900">
                {comment.avatar}
              </span>
              <div className="flex min-w-0 flex-col gap-1">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-900">
                    {comment.user}
                  </span>
                  <span className="text-xs text-foreground-400">
                    {comment.time}
                  </span>
                </div>
                <p className="text-sm leading-relaxed text-foreground-700">
                  {comment.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}